import React, { useEffect, useRef, useState } from "react";
import { Translate } from "react-localize-redux";
import { LinkedIn } from "react-linkedin-login-oauth2";
import translations from "../../translations/verify.json";
import signupTranslations from "../../translations/signup.json";
import welcomeTranslations from "../../translations/welcome.json";
import "../../styles/components/linkedinSharePopUp.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import StorageUtils from "../../backend/StorageUtils";
import { selectUser, userActions } from "../../store/features/user";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import Loader from "wallet-elementkit/dist/elementKit/loader/Loader";
import Checkmark from "../../assets/images/icons/checkmark.svg";
import InfoIcon from "../../assets/images/icons/info-icon.svg";
import SuccessIcon from "../../assets/images/icons/verified-icon.svg";
import ErrorIcon from "../../assets/images/icons/error.svg";
import Notification from "wallet-elementkit/dist/elementKit/notification/Notification";
import CloseIconGray from "../../assets/images/icons/close-icon-gray.svg";
import { signupLoginOtp } from "wallet-elementkit/dist/services/backend/User";
import { useHistory } from "react-router-dom";
import { storeItem, getItem, removeItem } from "../../backend/StorageUtils";
import Recaptcha from "../../elementKit/recaptcha/Recaptcha";
import { OrganizationBasedShareTexts } from "wallet-elementkit/dist/constants";
import {
	OptimizedMixPanel,
	EventsBackend,
} from "wallet-elementkit/dist/services";
import {
	getLinkedInUserIdProxy,
	getLinkedInAccessToken,
} from "../../services/verifiedBackendService/linkedin";
import mixpanel from "mixpanel-browser";
import { getPostLinkFromShareId } from "../../backend/LinkedinUtils";
import { UserRoles } from "../../constants/Enums";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import { postLinkedinArticle } from "wallet-elementkit/dist/services/backend/Linkedin";

const LinkedinSharePopUp = (props) => {
	props.addTranslation(translations);
	props.addTranslation(signupTranslations);
	props.addTranslation(welcomeTranslations);
	const dispatch = useAppDispatch();
	const userMeta = useAppSelector(selectUser);
	const history = useHistory();
	const params = useParams();

	const [triggerSharePopUp, setTriggerSharePopUp] = useState(
		props.triggerCanShareNow || false
	);
	const [shareLoading, setShareLoading] = useState(false);
	const [addLinkedinLoading, setAddLinkedinLoading] = useState(false);
	const [shareId, setShareId] = useState();
	const [isRedirected, setIsRedirected] = useState(false);
	const [postTitle, setPostTitle] = useState("");
	const [defaultPostTitle, setDefaultPostTitle] = useState("");
	const [addToProfile, setAddToProfile] = useState(true);
	const [shareToFeed, setShareToFeed] = useState(true);
	const [shareSuccessful, setShareSuccessful] = useState(true);
	const [error, setError] = useState(false);
	const [forceOpenSignup, setForceOpenSignup] = useState(false);
	const [forceOpenNotPermitted, setForceOpenNotPermitted] = useState(false);
	const [isLoggedInUserInner, setIsLoggedInUserInner] = useState(
		props.isLoggedInUser ?? false
	);
	const search = useLocation().search;
	const recaptchaRef = useRef(null);
	const [fromVerified, setFromVerified] = useState(false);
	const [loginLoading, setLoginLoading] = useState(false);

	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);

	useEffect(() => {
		if (!props.isCollection) {
			setFromVerified(search.includes("code"));
		}
		const skillTags =
			(props.skills &&
				props.skills.reduce((tags, skill) => {
					return (tags += `#${skill.title
						.toLocaleLowerCase()
						.replace(/\s+/g, "")} `);
				}, "")) ||
			"";

		const defaultPostTitle = props.isCollection
			? `Check out my verified collection issued by ${props.issued_by} ${process.env.REACT_APP_LINKEDIN_SHARE_TITLE_VIA}!\n${process.env.REACT_APP_LINKEDIN_SHARE_COMPANY_TAG} #digitalbadge #digitalcertificate #digitalcredentials ${skillTags}`
			: OrganizationBasedShareTexts.get(props.organization_id) ||
			  props.shareText ||
			  `Check out my ${props.credential_name} digital ${
					props.certificate_url && props.badge_url
						? "certificate/badge"
						: props.certificate_url
						? "certificate"
						: "badge"
			  } issued by ${props.issued_by} via ${
					process.env.REACT_APP_LINKEDIN_SHARE_TITLE_VIA
			  }!\n${
					process.env.REACT_APP_LINKEDIN_SHARE_COMPANY_TAG
			  } #digitalbadge #digitalcertificate #digitalcredentials ${skillTags}`;

		setPostTitle(defaultPostTitle);
		setDefaultPostTitle(defaultPostTitle);

		const shareOptions = getItem("linkedinShare");
		if (shareOptions) {
			const title = shareOptions.postTitle;
			setIsRedirected(true);
			setPostTitle(title);
			setAddToProfile(shareOptions.addToProfile);
			setShareToFeed(shareOptions.shareToFeed);
		}

		if (props.isCollection) setAddToProfile(false);
	}, []);

	useEffect(() => {
		if (fromVerified && props.tokenCode) {
			setShareLoading(true);
			setAddLinkedinLoading(true);
			handleLinkedinShareCode(props.tokenCode);
		}
	}, [fromVerified, props.linkedinAuthCode]);

	useEffect(() => {
		if (shareToFeed || addToProfile) setError(false);
	}, [shareToFeed, addToProfile]);

	useEffect(() => {
		if (props.tokenCode && props.userId && shareToFeed && !props.isCollection) {
			handleSubmit();
		}
	}, [props.tokenCode, props.userId, shareToFeed, props.isCollection]);

	useEffect(() => {
		if (props.triggerCanShareNow) {
			setTriggerSharePopUp(props.triggerCanShareNow || false);
		}
	}, [props.triggerCanShareNow]);

	function extractFirstAndLastNameFromStr(fullName) {
		fullName = fullName.trim();
		// get the last word of the string and make it last name then rest is first name
		const nameArr = fullName.split(" ");
		const lastName = nameArr[nameArr.length - 1];
		const firstName = nameArr.slice(0, nameArr.length - 1).join(" ");
		return [firstName, lastName];
	}

	useEffect(() => {
		if (shareLoading || addLinkedinLoading) setIsRedirected(true);
	}, [shareLoading, addLinkedinLoading]);

	useEffect(() => {
		if (shareToFeed || addToProfile) setError(false);
	}, [shareToFeed, addToProfile]);

	useEffect(() => {
		setIsLoggedInUserInner(
			props.userEmail
				? userMeta.user.email === props.userEmail ||
						userMeta.userEmails
							.map((e) => e.value.toLowerCase())
							.includes(props.userEmail.toLowerCase())
				: props.username
				? props.username === userMeta.user.username
				: props.isLoggedInUser ?? false
		);

		if (
			(props.logged &&
				userMeta.user.role === UserRoles.active &&
				props.isLoggedInUser) ||
			props.isCollection
		) {
			setForceOpenNotPermitted(false);
			setForceOpenSignup(false);
		}
	}, [userMeta, props.isLoggedInUser]);

	const triggerSignUpLoginOtp = async () => {
		const token = await recaptchaRef.current?.executeAsync();
		if (!token) {
			Notification({
				type: "error",
				text: props.translate("recaptchaError").toString(),
			});
			return;
		}
		setLoginLoading(true);
		if (userMeta.logged) {
			// LOG OUT
			optimizedMixpanel.track("Force Logout", {
				type: "Linkedin Share",
				credential_no: props.credential_no,
			});
			dispatch(userActions.logout());
			Notification({
				type: "success",
				text: props.translate("loggedOut"),
			});
		}

		const [firstName, lastName] = extractFirstAndLastNameFromStr(
			props.userFullName || "No Name"
		);

		const otpBody = {
			email: props.userEmail,
			reCaptchaToken: token || "",
			firstName: firstName,
			lastName: lastName,
		};
		StorageUtils.clearExceptConfig();
		const data = await signupLoginOtp(
			otpBody,
			"signup",
			getMasterConfig().subDomain
		);
		if (data != null && data.success) {
			dispatch(userActions.setUserId(data.userId));
			const actionType = "linkedinShare";
			history.push({
				pathname: `/${props.activeLanguage?.code ?? "en"}/verify-code`,
				search: `?email=${props.userEmail}`,
				state: {
					status: data.status,
					// Redirect After success key
					shouldRedirectOptions: {
						shouldRedirectTo: window.location.pathname,
						actionType: actionType,
					},
					// Redirect to back on header back button press
					fromProfile: true,
				},
			});
		} else {
			recaptchaRef.current?.reset();
			if (data) {
				Notification({
					type: "error",
					text: props.translate(data.error).toString(),
				});
			} else {
				Notification({
					type: "error",
					text: props.translate("error").toString(),
				});
			}
			setLoginLoading(false);
		}
		setLoginLoading(false);
	};

	const forceOpenPost = () => {
		const a = document.createElement("a");
		a.setAttribute("href", getPostLinkFromShareId(shareId));
		a.setAttribute("target", "_blank");
		a.click();
	};

	const handleClick = async (sharingFor, linkedinShareData) => {
		if (props.isCollection) return;
		EventsBackend.logShareEventAnon(
			props.credential_no,
			sharingFor,
			props.organization_id,
			linkedinShareData
		);
	};
	const handleLinkedinShareCode = async (code) => {
		await getLinkedInAccessToken(code).then(async (tokenCode) => {
			props.setLinkedinToken(tokenCode);
			await getLinkedInUserIdProxy(tokenCode).then(async (userId) => {
				props.setLinkedinUserId(userId);
			});
		});
	};

	const shareOnLinkedin = async () => {
		var resp = await postLinkedinArticle(
			props.tokenCode,
			props.userId,
			props.articleUrl,
			props.credential_name ??
				process.env.REACT_APP_LINKEDIN_SHARE_FALLBACK_CRED_NAME,
			postTitle,
			props.credential_no
		);
		setShareLoading(false);
		setPostTitle(defaultPostTitle);
		props.setLinkedinToken("");
		if (resp.shareId) {
			setShareSuccessful(true);
			setShareId(resp.shareId);
			props.isCollection
				? optimizedMixpanel.track("Collection Linkedin Share", {
						collection_id: params.id ?? "",
						isLoggedInUserInner: isLoggedInUserInner,
						isloggedin: userMeta.logged,
				  })
				: optimizedMixpanel.track("Linkedin Share", {
						credential_no: props.credential_no,
						isLoggedInUserInner: isLoggedInUserInner,
						isloggedin: userMeta.logged,
				  });
			handleClick("linkedin", {
				shareId: resp.shareId,
				credential_no: props.credential_no,
				postTitle: postTitle,
			});
			if (!addToProfile) {
				var win = window.open(getPostLinkFromShareId(resp.shareId));
				if (win == null) {
					forceOpenPost();
				} else {
					win.focus();
				}
			}
		} else {
			setShareId(undefined);
			setShareSuccessful(false);
		}
	};

	const handleSubmit = async () => {
		try {
			if (!addLinkedinLoading) setAddLinkedinLoading(true);
			if (!shareLoading) setShareLoading(true);

			if (!shareToFeed && !addToProfile) {
				setError(true);
				return;
			}
			if (shareToFeed) {
				await shareOnLinkedin();
				if (addToProfile) {
					props.addLinkedin();
					setAddLinkedinLoading(false);
				}
			} else if (!shareToFeed && addToProfile) {
				props.addLinkedin();
				props.handleClose();
			}

			removeItem("linkedinShare");
		} catch (e) {
			removeItem("linkedinShare");
			setShareLoading(false);
			setAddLinkedinLoading(false);
			setShareSuccessful(false);
			setShareId(undefined);
			setError(true);
		}
	};

	function showShareSheet() {
		const shouldShow =
			props.skipAuthForIssuerBadge ||
			((isLoggedInUserInner || props.isCollection) && !forceOpenNotPermitted) ||
			false;
		return shouldShow;
	}

	function removeTriggerStateFromLocation() {
		// For preventing the dialog to open again after refresh or closing
		history.replace({
			state: {
				fromVerification: undefined,
			},
		});
	}

	return showShareSheet() && triggerSharePopUp ? (
		<Modal
			id="share-dialog"
			className="verify-you"
			show={props.dialogOpen}
			onHide={props.handleClose}
			centered
		>
			<Modal.Body className="verify-you-body flex-row ai-fs">
				<img src={SuccessIcon} alt="Info Icon" className="modal-icon" />
				<div className="verify-you-texts">
					<span className="title-text">
						<Translate id="great" />
					</span>
					<span
						className="desc-text"
						style={{ marginTop: "15px", marginBottom: "15px" }}
					>
						{props
							.translate("nowShareWithEmailText")
							.toString()
							.replace("%email%", userMeta.user.email)}
					</span>
				</div>
			</Modal.Body>
			<Modal.Footer className="common-footer flex-row">
				<BaseButton
					type="secondary"
					size="small"
					loading={false}
					height={39}
					onClickAction={() => {
						removeTriggerStateFromLocation();
						props.handleClose();
					}}
				>
					<Translate id="cancel" />
				</BaseButton>
				<BaseButton
					type="primary"
					size="small"
					loading={loginLoading}
					height={39}
					onClickAction={() => {
						removeTriggerStateFromLocation();
						setTriggerSharePopUp(false);
					}}
				>
					<Translate id="proceedToShare" />
				</BaseButton>
			</Modal.Footer>
		</Modal>
	) : props.skipAuthForIssuerBadge ||
	  (props.logged &&
			userMeta.user.role === UserRoles.active &&
			!forceOpenSignup) ||
	  props.isCollection ? (
		showShareSheet() ? (
			<Modal
				id="share-dialog"
				onHide={props.handleClose}
				show={props.dialogOpen}
				centered
			>
				<Modal.Title className="dialog-title">
					<span className="s5">
						{props.isCollection ? (
							<Translate id="shareCollectionOnLinkedin" />
						) : (
							<Translate id="shareCredentialOnLinkedin" />
						)}
					</span>
				</Modal.Title>
				{isRedirected ? (
					<Modal.Body>
						{addToProfile && (
							<div className="flex-row ai-fs share-step">
								{addLinkedinLoading ? (
									<Loader
										type="primary"
										height={40}
										width={40}
										className="share-loader"
									/>
								) : props.redirectSuccessful ? (
									<img
										alt="Verified Check Icon"
										className="icon"
										src={Checkmark}
									/>
								) : (
									<img
										alt="Verified Error Icon"
										className="icon"
										src={ErrorIcon}
									/>
								)}

								<div className="flex-column ai-fs">
									<p className="s6 boldish step-title">
										<Translate id="addToProfile" />
									</p>
									<p className="s6">
										<Translate id="notRedirected" />{" "}
										<span onClick={() => props.addLinkedin?.()}>
											<Translate id="clickHere" />.
										</span>
									</p>
								</div>
							</div>
						)}
						{shareToFeed && (
							<div className="flex-row ai-fs share-step">
								{shareLoading ? (
									<Loader
										type="primary"
										height={40}
										width={40}
										className="share-loader"
									/>
								) : shareSuccessful ? (
									<img
										alt="Verified Check Icon"
										className="icon"
										src={Checkmark}
									/>
								) : (
									<img
										alt="Verified Error Icon"
										className="icon"
										src={ErrorIcon}
									/>
								)}
								<div className="flex-column ai-fs">
									<p className="s6 boldish step-title">
										<Translate id="shareToFeed" />
									</p>
									{shareLoading ? null : shareSuccessful ? (
										<p className="s6">
											<Translate id="shareSuccessful" />{" "}
											{shareId && (
												<span onClick={forceOpenPost}>
													<Translate id="seePost" />.
												</span>
											)}
										</p>
									) : (
										<p className="s6">
											<Translate id="shareFailed" />
										</p>
									)}
								</div>
							</div>
						)}
					</Modal.Body>
				) : (
					<Modal.Body>
						{!props.isCollection && (
							<Form.Group controlId="checkbox-group">
								<Form.Label className="s6-5 medium">
									{props.translate("shareOptions")}
								</Form.Label>
								<Form.Check
									type="checkbox"
									id="checkbox-1"
									className={error ? "error" : ""}
									label={props.translate("addToProfile")}
									checked={addToProfile}
									onChange={(e) => setAddToProfile(e.target.checked)}
								/>
								<Form.Check
									type="checkbox"
									id="checkbox-2"
									className={error ? "error" : ""}
									label={props.translate("shareToFeed")}
									checked={shareToFeed}
									onChange={(e) => setShareToFeed(e.target.checked)}
								/>
							</Form.Group>
						)}
						<Form.Group controlId="textarea">
							<Form.Label className="s6-5 medium">
								{props.translate("enterYourPost")}
							</Form.Label>
							<Form.Control
								as="textarea"
								placeholder={props.translate("enterYourPost").toString()}
								onChange={(e) => setPostTitle(e.target.value)}
								value={postTitle}
								style={{ height: "150px" }}
							/>
						</Form.Group>
					</Modal.Body>
				)}
				{isRedirected ? (
					<Modal.Footer>
						<BaseButton
							type="secondary"
							size="small"
							loading={false}
							width={80}
							onClickAction={() => props.handleClose()}
						>
							<Translate id="gotIt" />
						</BaseButton>
					</Modal.Footer>
				) : (
					<Modal.Footer>
						<BaseButton
							type="secondary"
							size="small"
							loading={false}
							width={80}
							onClickAction={() => props.handleClose()}
						>
							<Translate id="cancel" />
						</BaseButton>
						<LinkedIn
							clientId="775jdov7xhw33h"
							redirectUri={`${
								process.env.REACT_APP_LINKEDIN_BOUNCE_URL
							}?redirect_to=${window.location.href.toString().split("?")[0]}`}
							onSuccess={async (code) => handleLinkedinShareCode(code)}
							scope="r_emailaddress r_liteprofile w_member_social"
							closePopupMessage="Close Pop Up"
							onError={(error) => {
								console.log(error);
							}}
						>
							{({ linkedInLogin }) => (
								<BaseButton
									type="primary"
									size="small"
									loading={false}
									width={150}
									disabled={!shareToFeed && !addToProfile}
									onClickAction={() => {
										if (!props.isCollection && shareToFeed) {
											storeItem("linkedinShare", {
												shareToFeed: shareToFeed,
												addToProfile: addToProfile,
												postTitle: postTitle,
											});
											linkedInLogin();
										} else {
											handleSubmit();
										}
									}}
								>
									<Translate id="shareOnLinkedin" />
								</BaseButton>
							)}
						</LinkedIn>
					</Modal.Footer>
				)}
			</Modal>
		) : (
			<Modal
				id="share-dialog"
				className="not-permitted"
				show={props.dialogOpen}
				onHide={props.handleClose}
				centered
			>
				<Modal.Body className="not-permitted-body flex-row ai-fs">
					<img src={InfoIcon} alt="Info Icon" className="modal-icon" />
					<div className="not-permitted-texts">
						<span className="title-text">
							<Translate id="notPermittedToShareTitle" />
						</span>
						<span
							className="desc-text"
							style={{ marginTop: "15px", marginBottom: "15px" }}
						>
							{props
								.translate("notPermittedDescWithEmail")
								.toString()
								.replace("%email%", userMeta.user.email)}
						</span>
						<span className="desc-text">
							<Translate id="notPermittedSwitchText" />
						</span>
					</div>
				</Modal.Body>
				<Modal.Footer className="not-permitted-footer flex-row">
					<Recaptcha ref={recaptchaRef} />
					<BaseButton
						type="secondary"
						size="small"
						loading={false}
						height={39}
						onClickAction={() => props.handleClose()}
					>
						<Translate id="cancel" />
					</BaseButton>
					<BaseButton
						type="primary"
						size="small"
						loading={loginLoading}
						height={39}
						onClickAction={() => {
							triggerSignUpLoginOtp();
						}}
					>
						<Translate id="switchAccount" />
					</BaseButton>
				</Modal.Footer>
			</Modal>
		)
	) : props.activeLanguage && props.userEmail ? (
		<Modal
			id="share-dialog"
			className="verify-you"
			show={props.dialogOpen}
			onHide={props.handleClose}
			centered
		>
			<img
				src={CloseIconGray}
				alt="Close"
				className="close-icon"
				onClick={props.handleClose}
			/>
			<Modal.Body className="verify-you-body flex-row ai-fs">
				<img src={InfoIcon} alt="Info Icon" className="modal-icon" />
				<div className="verify-you-texts">
					<span className="title-text">
						<Translate id="weNeedToVerifyItsYou" />
					</span>
					<span
						className="desc-text"
						style={{ marginTop: "15px", marginBottom: "15px" }}
					>
						<Translate id="verifyItsYouDescText" />
					</span>
				</div>
			</Modal.Body>
			<Modal.Footer className="common-footer flex-row">
				<Recaptcha ref={recaptchaRef} />
				<BaseButton
					type="primary"
					size="small"
					loading={loginLoading}
					height={39}
					onClickAction={() => {
						triggerSignUpLoginOtp();
					}}
				>
					<Translate id="verifyEmailAddress" />
				</BaseButton>
			</Modal.Footer>
		</Modal>
	) : // <SignupPopup
	//     dialogOpen={props.dialogOpen}
	//     activeLanguage={props.activeLanguage!}
	//     closePopup={props.handleClose}
	//     handleClose={(mailConfirmed, userData) => {
	//         const isMailConfirmed =
	//             mailConfirmed ??
	//             new UserUtils(userMeta.user).isEmailConfirmed;

	//         const emailsToCheck = userData
	//             ? userData.userEmails
	//             : userMeta.userEmails;

	//         if (
	//             (props.logged &&
	//                 isMailConfirmed &&
	//                 (props.userEmail
	//                     ? emailsToCheck
	//                           .map((e) => e.value)
	//                           .includes(props.userEmail)
	//                     : props.username
	//                     ? props.username === userData?.user.username
	//                     : props.isLoggedInUser)) ||
	//             props.isCollection
	//         ) {
	//             setForceOpenNotPermitted(false);
	//             setForceOpenSignup(false);
	//         } else {
	//             setForceOpenNotPermitted(true);
	//             setForceOpenSignup(false);
	//         }
	//     }}
	//     translate={props.translate}
	//     addTranslation={props.addTranslation}
	// />
	null;
};

export default LinkedinSharePopUp;
